import {addEvent} from '../add-event'

export function refreshDataEvent(): boolean {
    return addEvent('reportsPageRefreshData', {})
}
